import React, { Component, PropTypes } from 'react';
import * as SvgIcons from 'components/Material/SvgIcons';
import { ToolbarButton } from 'components/Toolbar';
import { Colors, Units } from 'Css';

const css = oxygenCss({
  root: {
    display: 'flex',
    borderStyle: 'none none solid none',
    borderWidth: 1,
    borderColor: Colors.text.Dark.divider,
    boxSizing: 'border-box'
  },
  leftIcon: {
    boxSizing: 'border-box',
    padding: `${Units.base / 2}px 0`,
    flex: '0 0 48px'
  },
  rightIcon: {
    boxSizing: 'border-box',
    padding: `${Units.base / 2}px 0`,
    flex: '0 0 auto'
  },
  inputContainer: {
    boxSizing: 'border-box',
    padding: Units.base / 2,
    flex: '1 1 auto'
  },
  input: {
    margin: 0,
    border: 0,
    padding: 0,
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    boxSizing: 'border-box',
    lineHeight: '40px',
    width: '100%',
    height: 40,
    outline: 'none'
  }
});

class SearchBar extends Component {
  static propTypes = {
    searchText: PropTypes.string,
    placeholder: PropTypes.string,
    expandable: PropTypes.bool,
    expanded: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func,
    onRequestCollapse: PropTypes.func,
    onRequestExpand: PropTypes.func
  };

  static defaultProps = {
    expandable: true,
    expanded: true
  };

  focus = () => {
    this._input.focus();
    this._input.select();
  };

  handleChange = event => {
    const { value } = event.target;
    const { onChange } = this.props;
    onChange && onChange(value);
  };

  toggle = () => {
    const { expanded, onRequestCollapse, onRequestExpand } = this.props;
    if (expanded && onRequestCollapse) {
      onRequestCollapse();
    } else if (!expanded && onRequestExpand) {
      onRequestExpand();
    }
  };

  render() {
    const { expanded, expandable, placeholder, children } = this.props;
    const expandIcon =
      expandable && children ? (
        React.Children.only(children)
      ) : (
        <SvgIcons.HardwareKeyboardArrowRight />
      );

    return (
      <div className={css.root}>
        {expanded && (
          <div className={css.leftIcon}>
            <ToolbarButton onTouchTap={this.focus}>
              <SvgIcons.ActionSearch />
            </ToolbarButton>
          </div>
        )}
        {expanded && (
          <div className={css.inputContainer}>
            <input
              placeholder={placeholder}
              className={css.input}
              ref={_input => (this._input = _input)}
              onChange={this.handleChange}
            />
          </div>
        )}
        {!expandable &&
          children && <div className={css.rightIcon}>{children}</div>}
        {expandable && (
          <div className={css.rightIcon}>
            <ToolbarButton onTouchTap={this.toggle}>
              {expanded ? <SvgIcons.HardwareKeyboardArrowLeft /> : expandIcon}
            </ToolbarButton>
          </div>
        )}
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/js/components/Tasks/SearchBar.js